import { useTranslation } from '@mukil/i18n';
import { Badge, GlassCard } from '@jumpstone/ui-react';
import { FieldRow } from '../../../components/common/field_row';
import type { Employee } from '../../../data/types';

export function BankTab({
  employee,
}: {
  employee: Employee;
}): React.JSX.Element {
  const { t } = useTranslation('wp');

  return (
    <GlassCard className="rounded-2xl p-5">
      <h2 className="text-[14.5px] font-bold mb-1.5">
        {t('employees.bank_information')}
      </h2>
      <FieldRow label={t('employees.bank')}>{employee.bank.bank_name}</FieldRow>
      <FieldRow label={t('employees.account_number')}>
        <span className="num">{employee.bank.account_masked}</span>
      </FieldRow>
      <FieldRow label={t('employees.branch')}>{employee.bank.branch}</FieldRow>
      <FieldRow label={t('employees.verification')}>
        <Badge variant={employee.bank.verified ? 'success' : 'warning'}>
          {employee.bank.verified
            ? t('employees.verified')
            : t('employees.unverified')}
        </Badge>
      </FieldRow>
    </GlassCard>
  );
}

export function TaxTab({
  employee,
}: {
  employee: Employee;
}): React.JSX.Element {
  const { t } = useTranslation('wp');

  return (
    <GlassCard className="rounded-2xl p-5">
      <h2 className="text-[14.5px] font-bold mb-1.5">
        {t('employees.tax_information')}
      </h2>
      <FieldRow label={t('employees.tin')}>
        <span className="mono">{employee.tin}</span>
      </FieldRow>
      <FieldRow label={t('employees.apit_basis')}>
        {t('employees.apit_basis_regular')}
      </FieldRow>
      <FieldRow label={t('employees.exemptions')}>{t('common.none')}</FieldRow>
    </GlassCard>
  );
}
